import { render, staticRenderFns } from "./ModalGuideBookCTWA.vue?vue&type=template&id=20634c4a&scoped=true&"
import script from "./ModalGuideBookCTWA.vue?vue&type=script&lang=js&"
export * from "./ModalGuideBookCTWA.vue?vue&type=script&lang=js&"
import style0 from "./ModalGuideBookCTWA.vue?vue&type=style&index=0&id=20634c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20634c4a",
  null
  
)

export default component.exports